import { FileCategory } from './fileCategories';

export const uploadFieldCategoryMap: Record<string, string> = {
  // ================= ORGANIZATION =================
  misaalShareef: FileCategory.MISAAL_SHAREEF,

  directivesAlVazaratUsSaifiyah: FileCategory.DIRECTIVES,

  directivesPhoto: FileCategory.DIRECTIVES_PHOTO,

  mazaarPropertyMap: FileCategory.MAZAAR_PROPERTY_MAP,

  // ================= REGISTRATION =================
  addressProof: FileCategory.ADDRESS_PROOF,

  PTRDoc: FileCategory.PTR_DOCUMENT,

  ptrDocument: FileCategory.PTR_DOCUMENT,

  trustDeed: FileCategory.TRUST_DEED,

  trustRegistrationCertificate: FileCategory.TRUST_REGISTRATION_CERTIFICATE,

  changeReports: FileCategory.CHANGE_REPORTS,

  charityPermissions: FileCategory.CHARITY_PERMISSIONS,

  panCardOfTrust: FileCategory.PAN_CARD_OF_TRUST,

  registrationCertificates12AA80G: FileCategory.TWELVE_AA_80G_CERTIFICATES,

  resolutionRegisterMinutesBook: FileCategory.RESOLUTION_REGISTER,

  bankAccountDetails: FileCategory.BANK_ACCOUNT_DETAILS,

  waqfDeed: FileCategory.WAQF_DEED,

  waqfRegistrationCertificate: FileCategory.WAQF_REGISTRATION_CERTIFICATE,

  changeOrder: FileCategory.CHANGE_ORDER,

  intimationToWaqfBoard: FileCategory.WAQF_BOARD_INTIMATION,

  sanctionOrders: FileCategory.SANCTION_ORDERS,

  waqfBoardAuditReports: FileCategory.WAQF_BOARD_AUDIT_REPORTS,

  waqfPropertyListAsPerAct: FileCategory.WAQF_PROPERTY_LIST,

  // ================= PROPERTY =================
  propertyCard: FileCategory.PROPERTY_CARD,

  acquisitionDocument: FileCategory.ACQUISITION_DOCUMENT,

  nonAgriculturalCertificate: FileCategory.NON_AGRICULTURAL_CERTIFICATE,

  constructionPermissions: FileCategory.CONSTRUCTION_PERMISSIONS,

  buildingPlanApprovals: FileCategory.BUILDING_PLAN_APPROVALS,

  feePaymentReceipts: FileCategory.FEE_PAYMENT_RECEIPTS,

  environmentalClearance: FileCategory.ENVIRONMENTAL_CLEARANCE,

  fireSafetyCertificate: FileCategory.FIRE_SAFETY_CERTIFICATE,

  photos: FileCategory.PROPERTY_PHOTO,

  photo: FileCategory.PROPERTY_PHOTO,

  jantriDocument: FileCategory.JANTRI_DOCUMENT,

  houseTaxBill: FileCategory.PROPERTY_HOUSE_TAX_BILL,

  rentReceipts: FileCategory.RENT_RECEIPT,

  // ================= SUB PROPERTY =================
  commercialPropertiesList: FileCategory.COMMERCIAL_PROPERTIES_LIST,

  residentialPropertiesList: FileCategory.RESIDENTIAL_PROPERTIES_LIST,

  agriculturalLandsOnRent: FileCategory.AGRICULTURAL_LANDS_ON_RENT,

  tenantDisputeList: FileCategory.TENANT_DISPUTE_LIST,

  litigationCopies: FileCategory.LITIGATION_COPIES,

  waterBills: FileCategory.WATER_BILLS,

  propertyTaxBills: FileCategory.PROPERTY_TAX_BILLS,

  gasConnectionBills: FileCategory.GAS_CONNECTION_BILLS,

  digitalRecordsOfBills: FileCategory.DIGITAL_RECORDS_OF_BILLS,

  listOfCases: FileCategory.LIST_OF_CASES,

  caseFiles: FileCategory.CASE_FILES,

  interimFinalOrders: FileCategory.INTERIM_FINAL_ORDERS,

  judgmentCopies: FileCategory.JUDGMENT_COPIES,

  appealsFiled: FileCategory.APPEALS_FILED,

  closedCases: FileCategory.CLOSED_CASES,

  ongoingCases: FileCategory.ONGOING_CASES,

  advocateDetails: FileCategory.ADVOCATE_DETAILS,

  caseDocument: FileCategory.CASE_DOCUMENT,

  // ================= TENANT =================
  rentAgreement: FileCategory.RENT_AGREEMENT_DOCUMENT,

  // ================= LAND =================
  sanad: FileCategory.SANAD,

  registrationDocuments: FileCategory.REGISTRATION_DOCUMENT,

  titleDeed: FileCategory.TITLE_DEED,

  propertyMapSurveySketch: FileCategory.PROPERTY_MAP,

  titleClearance: FileCategory.TITLE_CLEARANCE,

  paymentProof: FileCategory.PAYMENT_PROOF,

  stampDutyProof: FileCategory.STAMP_DUTY_PROOF,

  saleGiftDeed: FileCategory.SALE_GIFT_DEED,

  mutationRecordProof: FileCategory.MUTATION_RECORD_PROOF,

  latestPropertyTaxReceipt: FileCategory.LATEST_PROPERTY_TAX_RECEIPT,

  surveyNumberRecords: FileCategory.SURVEY_NUMBER_RECORDS,

  mutationEntriesROR: FileCategory.MUTATION_ENTRIES_ROR,

  oldOwnershipDocuments: FileCategory.OLD_OWNERSHIP_DOCUMENTS,

  titleSearchReport: FileCategory.TITLE_SEARCH_REPORT,

  governmentAllotmentLetters: FileCategory.GOVERNMENT_ALLOTMENT_LETTERS,

  notice135D: FileCategory.NOTICE_135D,

  villageForm7: FileCategory.VILLAGE_FORM_7_12,

  villageForm8A: FileCategory.VILLAGE_FORM_8A,

  form6HaqPatraka: FileCategory.FORM_6_HAQ_PATRAKA,

  form6HaqPatrakaNondh: FileCategory.FORM_6_HAQ_PATRAKA_NONDH,

  utara5253: FileCategory.FIFTY_TWO_FIFTY_THREE_UTARA,

  talatiMap: FileCategory.TALATI_MAP,

  collectorOrderNAOrder: FileCategory.COLLECTOR_ORDER,

  leaseDeeds: FileCategory.LEASE_DEEDS,

  encumbranceCertificate: FileCategory.ENCUMBRANCE_CERTIFICATE,

  landPhotos: FileCategory.LAND_PHOTO,
};
